<template>
<div class="footer-content">
    <div class="created-by-texty">
        <p>Створено Текстами</p> 
        <img style="width: 180px" src="./white_logo.svg">
    </div>

    <div class="socio-wrapper" v-if="share_url">
      <p>Поширити:</p>

      <div class="socio-icons-box">
          <a class="icon-wrapper" :href="`https://www.facebook.com/sharer/sharer.php?u=${share_url}`">
              <img class="icon-box" src="./Vector.png"/>
              <img id="fb" style="" src="./fb.png"/>
          </a>

          <a class="icon-wrapper" :href="`https://twitter.com/intent/tweet?text=${share_url}`">>
              <img class="icon-box" src="./Vector.png"/>
              <img id="tw" style="" src="./tw.png"/>
          </a>
      </div>
    </div>
</div>
</template>

<script>
export default {
    name: "texty-footer",
    props: ["share_url"]
    // props: {"share_url": {type: String, default: null}}
}
</script>

<style lang="scss" scoped>

.footer-content {
  padding: 3em 0;
  display: flex;
  justify-content: space-between;
}

p {
  margin: 10px 0;
  color: #ECE9E5;
  // width: 100%;
  // // font-style: normal;
  // // font-weight: normal;
  // font-size: 16px;
  // line-height: 24px;
  // letter-spacing: -0.02em;
}

//колонка "створено текстами"
.created-by-texty {

}


//колонка "пошириити"
.socio-wrapper {
  //контейнер з іконками соцмереж
  .socio-icons-box {
    display: flex;
  }

  //контейнер з однією іконкою
  .icon-wrapper {
    margin-right: 12px;
    position: relative;
    width: 36px;
    height: 36px;
  }

  //рамка іконки
  .icon-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 36px;
    height: 36px;
  }

  //фб-іконка
  #fb {
    position: absolute;
    left: 36.11%;
    right: 36.11%;
    top: 25%;
    bottom: 22.22%;
    width: 10px;
    height: 19px;
  }

  //тв-іконка
  #tw {
    position: absolute;
    left: 25%;
    right: 25%;
    top: 27.78%;
    bottom: 30.56%;
    width: 18px;
    height: 15px;
  }
}

</style>